import {
  Box,
  Chip,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import TextFieldComponent from "../../../../../Components/TextFieldComponent";
import DropdownComponent from "../../../../../Components/DropdownComponent";
import Btn from "../../../../../Components/Ui_elements/Btn";
import { Close, Lock, Margin, Visibility, VisibilityOff } from "@mui/icons-material";
import MobileNumberField from "../../../../../Components/MobileNumberField";
import DatePickerComponent from "../../../../../Components/DatePickerComponent";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import RequestChangeModal from "../../../../../Components/Ui_elements/RequestChangeModal";
import DropdownWithSelectedList from "../../../../../Components/DropdownWithSelectedList";

const Step1Form = ({
  formData,
  setFormData,
  errors,
  handleChange,
  handleSubmit,
  resourceStatusList,
  handleAddAbsentPeriod,
  absentPeriods,
  handleDeleteAbsentPeriod,
  handleFileChange,
  profilePreview,
  setProfilePreview,
  currencyOptions,
  countryOptions,
  handleChangeRadio,
  isFreelancer,
  handleMultiSelectChange,
  specializationOptions,

  // start Profile request change state
  lockedFields,
  openChangeRequest,
  changeRequestOpen,
  setChangeRequestOpen,
  requestedField,
  oldValue,
  newValue,
  reason,
  setNewValue,
  setReason,
  onSubmitChangeRequest,
}) => {
  const { id } = useParams();
  const { iUserId, iFkUserTypeId } = useSelector(state => state?.root?.authUser?.user || {});
  const [showPastAbsences, setShowPastAbsences] = useState(false);
  const today = new Date();
  const dobMaxDate = new Date();
  dobMaxDate.setDate(dobMaxDate.getDate() - 1);

  // Check if current user is linguist
  const isLinguist = iFkUserTypeId === 2;
  const isEditMode = Boolean(id);
  const lockFields = isLinguist && isEditMode;

  const handleCheckboxChange = checked => {
    setFormData(prev => ({
      ...prev,
      norwayCurrency: checked,
      nokcurrency: checked ? "NOK" : "", // Select NOK when checked, clear when unchecked
    }));
  };

  const LockButton = ({ field }) =>
    lockedFields.includes(field) ? (
      <IconButton size="small" onClick={() => openChangeRequest(field)}>
        <Lock fontSize="small" />
      </IconButton>
    ) : null;

  return (
    <Box sx={{ background: "#fff", p: 2, borderRadius: 2 }}>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            {" "}
            <Box sx={{ p: 1 }}>
              <Typography variant="h6" marginBottom={2}>
                Basic Information
              </Typography>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <RadioGroup row value={isFreelancer} onChange={handleChangeRadio}>
                  <FormControlLabel
                    value="freelancer"
                    control={<Radio disabled={lockFields} />}
                    label="Freelance"
                  />
                  <FormControlLabel
                    value="translation"
                    control={<Radio disabled={lockFields} />}
                    label="Translation Agency"
                  />
                  {lockedFields.includes("freelancer") && <LockButton field="freelancer" />}
                </RadioGroup>
              </FormControl>
              {/* Row 12: Profile Upload */}
              <Grid item xs={12} md={9} xl={6} mb={2}>
                <Box sx={{ position: "relative" }}>
                  <Box
                    component="label"
                    className="file-upload-container"
                    htmlFor="upload-button"
                    sx={{ display: "inline-block" }}
                  >
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                      id="upload-button"
                    />
                    {profilePreview ? (
                      <img
                        src={profilePreview}
                        alt={isFreelancer === "translation" ? "Preview Logo" : "Preview Picture"}
                        width="70"
                        height="70"
                        style={{ objectFit: "cover" }}
                        onError={() => {
                          setProfilePreview(null);
                          setFormData(prevData => ({
                            ...prevData,
                            profilePicture: null,
                          }));
                        }}
                      />
                    ) : (
                      <Box className="file-upload-content">
                        <Typography variant="h3" sx={{ m: 0 }}>
                          {isFreelancer === "translation" ? "Upload Logo" : "Upload Profile"}
                        </Typography>
                      </Box>
                    )}
                  </Box>

                  {/* Close button outside the label to prevent file input opening */}
                  {profilePreview && (
                    <IconButton
                      onClick={e => {
                        e.stopPropagation();
                        setProfilePreview(null);
                        setFormData(prevData => ({
                          ...prevData,
                          profilePicture: null,
                        }));
                      }}
                      color="error"
                      size="small"
                      sx={{
                        position: "absolute",
                        left: "90%",
                        top: 5,
                        backgroundColor: "rgba(243, 73, 67, 0.15)",
                        "&:hover, &:focus": {
                          backgroundColor: "rgba(243, 73, 67, 0.15)",
                        },
                      }}
                    >
                      <Close />
                    </IconButton>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12}></Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} md={isLinguist ? 12 : 6}>
                  <TextFieldComponent
                    id="profileNumber"
                    name="profileNumber"
                    label="Profile Number"
                    value={formData.profileNumber}
                    isNotMandatory={true}
                    disabled
                    fullWidth
                  />
                </Grid>
                {!isLinguist && (
                  <Grid item xs={12} md={6}>
                    <DropdownComponent
                      id="resourceStatus"
                      name="resourceStatus"
                      label="Resource Status"
                      options={resourceStatusList || []}
                      value={formData.resourceStatus}
                      onChange={handleChange}
                      error={errors?.resourceStatus || ""}
                      isNotMandatory={false}
                      fullWidth
                    />
                  </Grid>
                )}
                <Grid item xs={12} md={6}>
                  <TextFieldComponent
                    id="firstName"
                    name="firstName"
                    label="First Name"
                    value={formData.firstName}
                    onChange={handleChange}
                    error={errors?.firstName || ""}
                    fullWidth
                    disabled={lockFields}
                    showLock={lockedFields.includes("firstName")}
                    onLockClick={() => openChangeRequest("firstName")}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextFieldComponent
                    id="lastName"
                    name="lastName"
                    label="Last Name"
                    value={formData.lastName}
                    onChange={handleChange}
                    error={errors?.lastName || ""}
                    fullWidth
                    disabled={lockFields}
                    showLock={lockedFields.includes("lastName")}
                    onLockClick={() => openChangeRequest("lastName")}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <DropdownComponent
                    id="gender"
                    name="gender"
                    label="Gender"
                    options={["Male", "Female", "Other"]}
                    value={formData.gender}
                    onChange={handleChange}
                    error={errors?.gender || ""}
                    isNotMandatory={true}
                    fullWidth
                    disabled={lockFields}
                  />
                </Grid>
                {/* Row 6: Date of Birth and Mobile */}
                <Grid item xs={12} md={6}>
                  <DatePickerComponent
                    id="dateOfBirth"
                    name="dateOfBirth"
                    label="Date of Birth"
                    value={formData.dateOfBirth}
                    onChange={handleChange}
                    error={errors?.dateOfBirth || ""}
                    maxDate={dobMaxDate}
                    isNotMandatory={true}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  {!isLinguist && (
                    <Grid container spacing={2}>
                      <Grid item xs={5} lg={6}>
                        <DropdownComponent
                          label="Currency Code"
                          name="currency"
                          value={formData?.currency}
                          onChange={handleChange}
                          options={currencyOptions}
                          searchable={true}
                          error={errors.currency || ""}
                        />
                      </Grid>
                      <Grid item xs={7} lg={6}>
                        <DropdownComponent
                          label="Second Currency"
                          name="nokcurrency"
                          value={formData.nokcurrency}
                          onChange={e =>
                            setFormData(prev => ({
                              ...prev,
                              nokcurrency: e.target.value,
                            }))
                          }
                          options={currencyOptions}
                          isNotMandatory={true}
                          error={errors.nokcurrency || ""}
                          showCheckbox={true}
                          checkboxLabel="Norway Currency"
                          checkboxChecked={formData.norwayCurrency}
                          onCheckboxChange={handleCheckboxChange}
                          disabled={true}
                        />
                      </Grid>
                    </Grid>
                  )}
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextFieldComponent
                    id="companyName"
                    name="companyName"
                    label="Company Name"
                    value={formData.companyName}
                    onChange={handleChange}
                    error={errors?.companyName || ""}
                    isNotMandatory={true}
                    fullWidth
                  />
                </Grid>

                {/* Row 10: Last Job */}
                <Grid item xs={12} md={6}>
                  <TextFieldComponent
                    id="lastJob"
                    name="lastJob"
                    label="Last Job"
                    value={formData.lastJob}
                    onChange={handleChange}
                    error={errors?.lastJob || ""}
                    fullWidth
                    isNotMandatory={true}
                    disabled
                  /> 
                </Grid>

                <Grid item xs={12} md={12}>
                  <Grid container spacing={2} alignItems={"flex-end"}>
                    <Grid item xs={5} lg={6}>
                      <DatePickerComponent
                        id="absentFrom"
                        name="absentFrom"
                        label="Linguist Absent From"
                        value={formData.absentFrom}
                        onChange={handleChange}
                        error={errors?.absentFrom || ""}
                        isNotMandatory={true}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={5} lg={4.5}>
                      <DatePickerComponent
                        id="absentTo"
                        name="absentTo"
                        label="Linguist Absent To"
                        value={formData.absentTo}
                        onChange={handleChange}
                        error={errors?.absentTo || ""}
                        isNotMandatory={true}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={2} lg={1.5}  justifyContent="flex-start">
                      <Btn variant="contained" color="primary" size="small" onClick={handleAddAbsentPeriod}>
                        OK
                      </Btn>
                    </Grid>
                  </Grid>

                  <Box display="flex" alignItems="center" gap={1}>
                    <IconButton
                      color="primary"
                      onClick={() => setShowPastAbsences(prev => !prev)}
                      sx={{ ml: 1 }}
                      title={showPastAbsences ? "Hide past absences" : "Show past absences"}
                    >
                      {showPastAbsences ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                    <Typography variant="body2">See absent list</Typography>
                  </Box>
                  {/* Render Absent Period Chips */}
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
                    {/* Filter visible absences */}
                    {absentPeriods
                      .filter(period => showPastAbsences || new Date(period.to) >= today)
                      .map(period => {
                        const isPast = new Date(period.to) < today;
                        return (
                          <Chip
                            key={period.id}
                            label={`${period.from} to ${period.to}`}
                            //onDelete={!isPast ? () => handleDeleteAbsentPeriod(period.id) : undefined}
                            onDelete={
                              !isPast || period.isNew
                                ? () => handleDeleteAbsentPeriod(period.id)
                                : undefined
                            }
                            sx={{
                              opacity: isPast ? 0.6 : 1,
                              cursor: isPast ? "not-allowed" : "pointer",
                            }}
                          />
                        );
                      })}
                  </Box>

                  <Box sx={{ mt: 2 }}>
                    <DropdownWithSelectedList
                      label="Specialization"
                      name="specialization"
                      value={formData.specialization || []}
                      onChange={handleMultiSelectChange}
                      options={specializationOptions || []}
                      error={errors?.specialization || ""}
                      required={false}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={{ p: 1 }}>
              <Typography variant="h6" marginBottom={2}>
                Profile Information
              </Typography>
              <Grid container spacing={2}>
                {/* <Grid item xs={12} md={12}>
                  <TextFieldComponent
                    id="username"
                    name="username"
                    label="Username"
                    value={formData.username}
                    onChange={handleChange}
                    error={errors?.username || ""}
                    isNotMandatory={true}
                    fullWidth
                  />
                </Grid> */}
                <Grid item xs={12} md={12}>
                  <TextFieldComponent
                    id="email"
                    name="email"
                    label="Email Address"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    error={errors?.email || ""}
                    fullWidth
                    disabled={lockFields}
                    showLock={lockedFields.includes("email")}
                    onLockClick={() => openChangeRequest("email")}
                  />
                </Grid>
                {!isLinguist && (
                  <Grid item xs={12} md={12}>
                    <TextFieldComponent
                      id="password"
                      name="password"
                      label="Password"
                      type="password"
                      value={id && iUserId != id ? "password" : formData.password}
                      onChange={handleChange}
                      error={errors?.password || ""}
                      isNotMandatory={true}
                      autogenerate={true}
                      disabled={id && iUserId != id}
                      disableEye={id && iUserId != id}
                      fullWidth
                    />
                  </Grid>
                )}
                <Grid item xs={12} md={6}>
                  <TextFieldComponent
                    id="secondaryEmail"
                    name="secondaryEmail"
                    label="Secondary Email Address"
                    type="email"
                    value={formData.secondaryEmail}
                    onChange={handleChange}
                    error={errors?.secondaryEmail || ""}
                    isNotMandatory={true}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextFieldComponent
                    id="website"
                    name="website"
                    label="Website"
                    type="text"
                    value={formData.website}
                    onChange={handleChange}
                    error={errors?.website || ""}
                    isNotMandatory={true}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <MobileNumberField
                    id="mobile"
                    name="mobile"
                    label="Mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    error={errors?.mobile || ""}
                    isNotMandatory={true}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextFieldComponent
                    id="skype"
                    name="skype"
                    label="Teams/Slack Username"
                    value={formData.skype}
                    onChange={handleChange}
                    error={errors?.skype || ""}
                    isNotMandatory={true}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  {!isLinguist && (
                    <TextFieldComponent
                      name="memo"
                      label="Memo"
                      value={formData.memo}
                      onChange={handleChange}
                      error={errors?.memo || ""}
                      isNotMandatory={true}
                      fullWidth
                      multiline
                    />
                  )}
                </Grid>
                {/* Address Section (moved here) */}
                <Grid item xs={12} md={12}>
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="h6" marginBottom={2}>
                      Address
                    </Typography>
                    <Grid container spacing={2}>
                      {/* First Row - Street, Country, State */}
                      <Grid item xs={12} md={6}>
                        <TextFieldComponent
                          type="text"
                          name="vAddress1"
                          label="Street"
                          value={formData.vAddress1}
                          onChange={handleChange}
                          error={errors.vAddress1 || ""}
                          isNotMandatory={true}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <DropdownComponent
                          label="Country"
                          name="country"
                          value={formData.country}
                          onChange={handleChange}
                          options={countryOptions}
                          error={errors.country || ""}
                          isNotMandatory={true}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextFieldComponent
                          type="text"
                          name="state"
                          label="State"
                          value={formData.state}
                          onChange={handleChange}
                          error={errors.state || ""}
                          isNotMandatory={true}
                          fullWidth
                        />
                      </Grid>

                      {/* Second Row - City, Zipcode, TimeZone */}
                      <Grid item xs={12} md={6}>
                        <TextFieldComponent
                          type="text"
                          name="vCity1"
                          label="City"
                          value={formData.vCity1}
                          onChange={handleChange}
                          error={errors.vCity1 || ""}
                          isNotMandatory={true}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextFieldComponent
                          type="text"
                          name="zipcode"
                          label="Zipcode"
                          value={formData.zipcode}
                          onChange={handleChange}
                          error={errors.zipcode || ""}
                          isNotMandatory={true}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextFieldComponent
                          type="text"
                          name="timezone"
                          label="TimeZone"
                          value={formData.timezone}
                          onChange={handleChange}
                          error={errors.timezone || ""}
                          isNotMandatory={true}
                          fullWidth
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </form>

      <RequestChangeModal
        open={changeRequestOpen}
        onClose={() => setChangeRequestOpen(false)}
        field={requestedField}
        oldValue={oldValue}
        newValue={newValue}
        reason={reason}
        setNewValue={setNewValue}
        setReason={setReason}
        onSubmit={onSubmitChangeRequest}
      />
    </Box>
  );
};

export default Step1Form;
